import React from "react"
import { CLOSE_FRIENDS } from "constants/index"
import { PREMIUM_FALLBACK_MODE } from "constants/premium"
import { PremiumFallbackMode } from "types/premium.types"
import UpdateCloseFriendsTemplate from "components/templates/UpdateCloseFriendsTemplate"
import withPremiumPermission from "components/HOCs/withPremiumPermission"

export default function CloseFriendsPage() {
  return (
    <UpdateCloseFriendsTemplateWithRoleBasedPermissionCheck
      feature={CLOSE_FRIENDS}
      mode={PREMIUM_FALLBACK_MODE.REDIRECT as PremiumFallbackMode}
    />
  )
}

const UpdateCloseFriendsTemplateWithRoleBasedPermissionCheck = withPremiumPermission(UpdateCloseFriendsTemplate)
